import { useQuery } from '@apollo/client';

export default function useDetailQuery (query, id, options = {}, posType) {
	// Allow callers to pass extra variables (e.g. crossTenant) while ensuring we always send id/posType.
	const { variables: optionVariables, ...otherOptions } = options || {};
	const variables = {
		...(optionVariables || {}),
		...(id !== undefined ? { id } : {}),
		...(posType !== undefined ? { posType } : {}),
	};

	const { data: rawData, ...otherReponseItems } = useQuery(query, {
		fetchPolicy: 'cache-and-network',
		errorPolicy: 'all',
		notifyOnNetworkStatusChange: true,
		...otherOptions,
		variables,
	});

	// Extract the detail information ("item") from data, using the operationName as key
	const operationName = query.definitions[0].selectionSet.selections[0].name.value.toString();
	const data = rawData ? rawData[operationName] : rawData;

	return { data, ...otherReponseItems };
}
